import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const EngagingIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 20 20"
      data-fill-none
    >
      <path
        d="M17.1593 14.9576H9.44916L5.04336 18.262V14.9576H2.84046C2.54834 14.9576 2.26818 14.8416 2.06162 14.635C1.85506 14.4285 1.73901 14.1483 1.73901 13.8562V2.84168C1.73901 2.54956 1.85506 2.2694 2.06162 2.06284C2.26818 1.85628 2.54834 1.74023 2.84046 1.74023H17.1593C17.4514 1.74023 17.7316 1.85628 17.9381 2.06284C18.1447 2.2694 18.2608 2.54956 18.2608 2.84168V13.8562C18.2608 14.1483 18.1447 14.4285 17.9381 14.635C17.7316 14.8416 17.4514 14.9576 17.1593 14.9576Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
